import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { companyClient } from '../client/companyClient';


type Options = {
  enabled: boolean
  retry?: boolean;
};

const defaultOptions: Partial<Options> = {
  enabled: true,
  retry: false,
};

export const useCompaniesQuery = (params: Companies.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getCompanies, params],
    queryFn: () => companyClient.getCompanies(params),
    enabled: options.enabled,
    retry: options.retry,
  });

  return {
    ...rest,
    count: data?.count || 0,
    companies: data?.results || [],
  };
};
